type LaunchDarklyConfig = {
  clientSideID: string;
};

export const LAUNCH_DARKLY_CONFIG: LaunchDarklyConfig = {
  clientSideID: window.__app_config.WEBUI_LAUNCHDARKLY_CLIENT_SIDE_ID,
};
